<template>
  <el-dialog :title="title" :visible="visible" width="70%" @close="handleClose">
    <el-form
      label-width="120px"
      ref="editForm"
      :model="editForm"
      :rules="rules"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="票号" prop="moneyOrderCode">
            <el-input
              size="small"
              v-model="editForm.moneyOrderCode"
              auto-complete="off"
              placeholder="票号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="承兑人" prop="acceptorName">
            <el-input
              size="small"
              v-model="editForm.acceptorName"
              auto-complete="off"
              placeholder="承兑人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="入库日期" prop="createDate">
            <el-date-picker
              style="width: 180px"
              size="small"
              v-model="editForm.createDate"
              value-format="yyyy-MM-dd hh:mm:ss"
              type="date"
              placeholder="入库日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入库客户" prop="customerName">
            <el-input
              size="small"
              v-model="editForm.customerName"
              auto-complete="off"
              placeholder="入库客户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入库业务员" prop="inSalesman">
            <el-autocomplete
              size="small"
              v-model="editForm.inSalesman"
              :fetch-suggestions="querySearch"
              placeholder="输入内容自动匹配业务员"
              :trigger-on-focus="false"
              @select="
                handleConfirmSelectSaleman($event, editForm, 'inSalesman')
              "
            >
              <template slot-scope="{ item }">
                <div>
                  {{ item.realName + "（" + item.dept.deptName + "）" }}
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="出库日期" prop="outDate">
            <el-date-picker
              style="width: 180px"
              size="small"
              v-model="editForm.outDate"
              value-format="yyyy-MM-dd hh:mm:ss"
              type="date"
              placeholder="出库日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库客户" prop="outCustomerName">
            <el-input
              size="small"
              v-model="editForm.outCustomerName"
              auto-complete="off"
              placeholder="出库客户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库业务员" prop="outSalesman">
            <el-autocomplete
              size="small"
              v-model="editForm.outSalesman"
              :fetch-suggestions="querySearch"
              placeholder="输入内容自动匹配业务员"
              :trigger-on-focus="false"
              @select="
                handleConfirmSelectSaleman($event, editForm, 'outSalesman')
              "
            >
              <template slot-scope="{ item }">
                <div>
                  {{ item.realName + "（" + item.dept.deptName + "）" }}
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="出库中介业务员" prop="outInterSalesman">
            <el-autocomplete
              size="small"
              v-model="editForm.outInterSalesman"
              :fetch-suggestions="querySearch"
              placeholder="输入内容自动匹配业务员"
              :trigger-on-focus="false"
              @select="
                handleConfirmSelectSaleman($event, editForm, 'outInterSalesman')
              "
            >
              <template slot-scope="{ item }">
                <div>
                  {{ item.realName + "（" + item.dept.deptName + "）" }}
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="票面金额（万）" prop="faceValue">
            <el-input-number
              :min="0"
              size="small"
              :controls="false"
              v-model="editForm.faceValue"
              placeholder="票面金额（万）"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="进价(%)" prop="inPercentage">
            <el-input-number
              :min="0"
              :max="100"
              :controls="false"
              size="small"
              v-model="editForm.inPercentage"
              placeholder="进价(%)"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="扣资" prop="deductionPrice">
            <el-input-number
              :min="0"
              :controls="false"
              size="small"
              v-model="editForm.deductionPrice"
              placeholder="扣资"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="进价票据价值" prop="inFaceValue">
            <el-input-number
              :min="0"
              :controls="false"
              size="small"
              disabled
              v-model="editForm.inFaceValue"
              placeholder="进价票据价值"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="售价(%)" prop="outPercentage">
            <el-input-number
              :min="0"
              :max="100"
              :controls="false"
              size="small"
              v-model="editForm.outPercentage"
              placeholder="售价(%)"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="资金利润" prop="capitalProfit">
            <el-input-number
              :min="0"
              size="small"
              disabled
              :controls="false"
              v-model="editForm.capitalProfit"
              placeholder="资金利润"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务利润" prop="businessProfit">
            <el-input-number
              :min="0"
              size="small"
              disabled
              :controls="false"
              v-model="editForm.businessProfit"
              placeholder="业务利润"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入库佣金" prop="inSalesmanCommission">
            <el-input-number
              :min="0"
              size="small"
              disabled
              :controls="false"
              v-model="editForm.inSalesmanCommission"
              placeholder="入库佣金"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="出库佣金" prop="outSalesmanCommission">
            <el-input-number
              :min="0"
              size="small"
              disabled
              :controls="false"
              v-model="editForm.outSalesmanCommission"
              placeholder="出库佣金"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库中介佣金" prop="outInterSalesmanCommission">
            <el-input-number
              :min="0"
              size="small"
              disabled
              :controls="false"
              v-model="editForm.outInterSalesmanCommission"
              placeholder="出库中介佣金"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报价员" prop="inBidder">
            <el-autocomplete
              size="small"
              v-model="editForm.inBidder"
              :fetch-suggestions="querySearch"
              placeholder="输入内容自动匹配业务员"
              :trigger-on-focus="false"
              @select="handleConfirmSelectSaleman($event, editForm, 'inBidder')"
            >
              <template slot-scope="{ item }">
                <div>
                  {{ item.realName + "（" + item.dept.deptName + "）" }}
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="报价成本（%）" prop="inOffer">
            <el-input-number
              :min="0"
              size="small"
              :controls="false"
              v-model="editForm.inOffer"
              placeholder="报价成本（%）"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="差价（元）" prop="differencePrice">
            <el-input-number
              :min="0"
              size="small"
              :controls="false"
              disabled
              v-model="editForm.differencePrice"
              placeholder="差价（元）"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="票据类型" prop="type">
            <el-input
              size="small"
              value="纸票"
              auto-complete="off"
              :disabled="true"
              placeholder="票据类型"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="瑕疵情况" prop="flaw">
            <el-input
              size="small"
              v-model="editForm.flaw"
              auto-complete="off"
              placeholder="瑕疵情况"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { addCheck } from "@/api/ticket/check";
import { listSalesman } from "@/api/system/user";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({
        type: "纸票",
      }),
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rules: {
        moneyOrderCode: [
          { required: true, message: "请输入票号", trigger: "change" },
        ],
        customerName: [
          { required: true, message: "请填写客户名称", trigger: "change" },
        ],
        faceValue: [
          { required: true, message: "请填写票面金额", trigger: "change" },
        ],
        inSalesman: [
          { required: true, message: "请填写入库业务员", trigger: "change" },
        ],
        inPercentage: [
          { required: true, message: "请填写进价", trigger: "change" },
        ],
        deductionPrice: [
          { required: true, message: "请填写扣资", trigger: "change" },
        ],
        outPercentage: [
          { required: true, message: "请填写售价", trigger: "change" },
        ],
        acceptorName: [
          { required: true, message: "请填写承兑人", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, originData, type) {
      if (data) {
        if (type === "inSalesman") {
          originData.inSalesman = data.realName;
          originData.inSalesmanId = data.id;
        } else if (type === "outSalesman") {
          originData.outSalesman = data.realName;
          originData.outSalesmanId = data.id;
        } else if (type === "inBidder") {
          originData.inBidder = data.realName;
          originData.inBidderId = data.id;
        } else if (type === "outInterSalesman") {
          originData.outInterSalesman = data.realName;
          originData.outInterSalesmanId = data.id;
        }
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          addCheck(this.editForm)
            .then(() => {
              this.$message({
                message: `${this.editForm.id ? "编辑" : "保存"}成功`,
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.error);
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("update:editForm", {});
      this.$refs.editForm.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-check-rollback/add-edit/index.vue